export default __webpack_public_path__ + "static/poolEquipmentSales-4b105f74c09849e645a0d210a4f2fe72.jpg";